export default "__VITE_ASSET__CiHbtcBs__"